import { EditNotificationOutDto, EditNotificationInDto } from '../../../types/notification.dto'

export const EDIT_NOTIFICATION = 'EDIT_NOTIFICATION'
export const EDIT_NOTIFICATION_SUCCESS = 'EDIT_NOTIFICATION_SUCCESS'
export const EDIT_NOTIFICATION_ERROR = 'EDIT_NOTIFICATION_ERROR'
export const RESET_EDIT_NOTIFICATION = 'RESET_EDIT_NOTIFICATION'

export interface EditNotification {
  type: typeof EDIT_NOTIFICATION
  payload: EditNotificationOutDto
}

export interface EditNotificationSuccess {
  type: typeof EDIT_NOTIFICATION_SUCCESS
  payload: EditNotificationInDto
}

export interface EditNotificationError {
  type: typeof EDIT_NOTIFICATION_ERROR
  payload: string | boolean
}

export interface ResetEditNotification {
  type: typeof RESET_EDIT_NOTIFICATION
  payload: null
}
export interface State {
  data: EditNotificationInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditNotification | EditNotificationSuccess | EditNotificationError | ResetEditNotification
